export type ThumbnailData = number[];

// Decodes the browse thumbnail's wire format — a base64 string of one byte per
// column (absolute peak, 0..255) as baked by the engine and stored in Firestore
// — into normalised peak magnitudes (0..1). Returns [] for an empty/invalid
// string so callers can treat "no thumbnail" uniformly.
export function decodeThumbnail(base64: string): ThumbnailData {
    if (!base64) return [];
    try {
        const binary = atob(base64);
        const peaks = new Array<number>(binary.length);
        for (let i = 0; i < binary.length; i++) {
            peaks[i] = binary.charCodeAt(i) / 255;
        }
        return peaks;
    } catch {
        return [];
    }
}
